import { Component, inject, signal } from '@angular/core';

import { SessionStore } from '../../../../store/session.store';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { MFAService } from '../../services/mfa.service';
import { DialogService } from '@ngneat/dialog';
import { NgIf } from '@angular/common';
import { QRCodeComponent } from 'angularx-qrcode';
import { AppleInputComponent } from '../apple-input/apple-input.component';
import { AppleButtonComponent } from '../apple-button/apple-button.component';

@Component({
	selector: 'app-two-step-verification',
	templateUrl: './two-step-verification.component.html',
	styleUrls: ['./two-step-verification.component.scss'],
	imports: [NgIf, QRCodeComponent, FormsModule, ReactiveFormsModule, AppleInputComponent, AppleButtonComponent],
})
export class TwoStepVerificationComponent {
	private _mfaService = inject(MFAService);
	private _dialog = inject(DialogService);

	public store = inject(SessionStore);

	public provisioningQRCode = signal('');
	public provisioningCode = signal('');

	public form = new FormGroup({
		code: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
	});

	ngOnInit() {
		if (!this.store.user().otp.confirmed) {
			this._mfaService.setup().subscribe((result) => {
				this.provisioningQRCode.set(result.provisioningUri);
				this.provisioningCode.set(result.secretKey);
			});
		}
	}

	verifyOTP() {
		if (this.form.valid && this.form.value.code) {
			this._mfaService.verify(this.form.value.code).subscribe((result) => {
				if (result) {
					this.store.initialize();
					this._dialog.closeAll();
				}
			});
		}
	}
}
